// extracted by mini-css-extract-plugin
export var current = "pagination-module--current--43c8d";
export var firstitem = "pagination-module--firstitem--61303";
export var item = "pagination-module--item--d9d87";
export var lastchild = "pagination-module--lastchild--c89fd";
export var lastitem = "pagination-module--lastitem--bc8f9";
export var pagination = "pagination-module--pagination--e5305";